import { render, staticRenderFns } from "./incomeTaxDeclaration.vue?vue&type=template&id=2cbfac6e&scoped=true"
import script from "./incomeTaxDeclaration.vue?vue&type=script&lang=js"
export * from "./incomeTaxDeclaration.vue?vue&type=script&lang=js"
import style0 from "./incomeTaxDeclaration.vue?vue&type=style&index=0&id=2cbfac6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbfac6e",
  null
  
)

export default component.exports